import * as React from 'react';
import * as _ from 'lodash'
import { CompanyT } from '../../../types/Company';
import CompanyWorkerLineItem from './CompanyWorkerLineItem';


export type ICompanyWorkersProps = {
    company: CompanyT
    updateCompany(company: CompanyT): void
}


const CompanyWorkersTab: React.FC<ICompanyWorkersProps> = ({ company,updateCompany }) => {
    const [workers, setWorkers] = React.useState([]);
    React.useEffect(() => {
        if (company.workers && _.isArray(company.workers)) {
            setWorkers(company.workers)
        }
    }, [company]);

    return (
        <div>
            <h3>Manage Workers</h3>
            {workers.map((id: number, index) => {
                return (
                    <CompanyWorkerLineItem workerId={id} company={company} updateCompany={updateCompany} key={index} />
                )
            })}
        </div>
    );
}
export default CompanyWorkersTab;
export { CompanyWorkersTab };